import { setState } from './helpers'

const commonMutations = {
  SET_PAGINATION: setState('pagination'),
  SET_PAGINATION_ACTIVITY: setState('paginationActivity'),
  SET_PAGINATION_ACTIVITY_GLOBAL: setState('paginationGlobalActivity')
}

export { commonMutations }
